import { PersonalDetails as DefaultPersonDetails } from "src/components/feature/Onboarding";

const PersonalDetails = () => {
  return <DefaultPersonDetails />;
};

export default PersonalDetails;
